export const rewardDetail = {
    border: true,
    index: false,
    stripe: true,
    align:'center',
    menu: false,
    addBtn: false,
    refreshBtn: false,
    columnBtn: false,
    column: [
    {
        label: 'ID',
        prop: 'id',
        hide: true,
    },{
        label: '行为描述',
        prop: 'rewardRule',
    },{
        label: '来源',
        prop: 'entityId',
    },{
        label: '原因',
        prop: 'comment',
    },{
        label:'积分值',
        prop:'rewardValue',
    },{
        label: '获得日期',
        prop: 'insertedTime',
        format: 'yyyy-MM-dd HH:mm:ss',
        valueFormat: 'yyyy-MM-dd HH:mm:ss',
    }]
  }